import React from 'react';
import { bool, shape, string } from 'prop-types';

const WorkTypeColor = ({
  className = 'icon',
  notUseClass = false,
  color = '#696f88',
  style = {},
}) => (
  <svg className={notUseClass ? '' : className} style={{ color, ...style }} width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5.25 4.32848C3.8775 5.42348 3 7.11098 3 9.00098C3 12.0535 5.295 14.581 8.25 14.9485V16.4635C4.4625 16.0885 1.5 12.8935 1.5 9.00098C1.5 6.75848 2.49 4.74848 4.05 3.37598H2.25V1.87598H6.75V5.62598H5.25V4.32848Z" fill="currentColor" />
    <path d="M15 9.00098C15 10.891 14.1225 12.571 12.75 13.6735V12.376H11.25V16.126H15.75V14.626H13.95C15.51 13.2535 16.5 11.2435 16.5 9.00098H15Z" fill="currentColor" />
    <path fillRule="evenodd" clipRule="evenodd" d="M15.5244 2.46416C15.6761 2.61252 15.7579 2.8182 15.7494 3.03022C15.6711 4.99641 15.3318 7.39059 14.0337 9.02489L14.0304 9.02901C12.874 10.4642 11.227 10.9978 9.75 11.1836V14.2504H8.25V12.6735C7.35518 12.5306 6.36706 12.1759 5.6465 11.3174L5.64312 11.3133C4.76327 10.2499 4.54998 8.72093 4.50065 7.53146C4.49186 7.31956 4.57319 7.11384 4.72452 6.96525C4.87584 6.81665 5.08301 6.73907 5.29472 6.75172C6.29608 6.81153 7.58578 7.07002 8.49917 8.06458C8.73506 6.76522 9.17051 5.47776 9.96627 4.47587L9.96956 4.47176C11.3139 2.80339 13.321 2.35339 14.9534 2.25183C15.1652 2.23865 15.3727 2.31581 15.5244 2.46416ZM11.1392 5.41086C10.3107 6.45543 9.94209 8.02707 9.80291 9.66183C10.9856 9.47876 12.096 9.03774 12.8608 8.08989C13.6893 7.04532 14.0579 5.47368 14.1971 3.83894C13.0144 4.022 11.9041 4.46302 11.1392 5.41086ZM8.17444 11.1314C8.06715 10.3345 7.84862 9.62532 7.45286 9.1457C7.10967 8.73794 6.6281 8.49922 6.07556 8.3694C6.18285 9.16628 6.40138 9.87545 6.79715 10.3551C7.14034 10.7628 7.6219 11.0015 8.17444 11.1314Z" fill="currentColor" />
  </svg>
);

WorkTypeColor.propTypes = {
  className: string,
  notUseClass: bool,
  color: string,
  style: shape({}),
};

export default WorkTypeColor;
